export const highlightMatch = (text: string, query: string) => {
  const regex = new RegExp(`(${query})`, "gi");
  return text.split(regex).map((part, index) => (part.toLowerCase() === query.toLowerCase() ? <b key={index}>{part}</b> : part));
};
